import { useMemoizedGet } from 'src/shared/composables/useStrapiApi';
import type { ApiRegisterPresentationRegisterPresentation } from 'src/types/contentTypes';
import type { Parameters } from 'src/types/strapi/strapiParameters';

let _data: ApiRegisterPresentationRegisterPresentation;
const params: Parameters = {
  fields: ['actionBtnText', 'route'],
  // populate: '*',
  populate: {
    image: {
      fields: ['url', 'width', 'mime', 'formats'],
    },
    imageMobile: {
      fields: ['url', 'width', 'mime', 'formats'],
    },
  },
};

export async function getRegisterPresentationData(locale?: string) {
  if (locale) {
    // short locale string (e.g. 'en', 'he')
    params.locale = locale.split('-')[0];
  } else if (import.meta.env?.VITE_I18N_DEFAULT_LOCALE) {
    // default locale ukranian
    params.locale = import.meta.env.VITE_I18N_DEFAULT_LOCALE;
  } else {
    // strapi default locale 'uk'
    params.locale = 'uk';
  }

  if (_data) return _data;
  const { data, error } = await useMemoizedGet(
    'register-presentation',
    params,
    {
      suppressError: true,
    },
  );
  if (error.value) {
    throw new Error(error.value as string);
  }
  _data = data.value.data as ApiRegisterPresentationRegisterPresentation;
  return _data;
}

export function imageUrl(
  img: 'image' | 'imageMobile',
  size: 'small' | 'medium' | 'large' | 'original',
) {
  return size === 'original'
    ? // @ts-expect-error next-line
      _data?.[img]?.url
    : // @ts-expect-error next-line
      _data?.[img]?.formats?.[size]?.url;
}

export function imageSize(
  img: 'image' | 'imageMobile',
  size: 'small' | 'medium' | 'large' | 'original',
) {
  return size === 'original'
    ? // @ts-expect-error next-line
      _data?.[img]?.width
    : // @ts-expect-error next-line
      _data?.[img]?.formats?.[size]?.width;
}

export function imageMime(img: 'image' | 'imageMobile') {
  // @ts-expect-error next-line
  return _data?.[img]?.mime;
}
